import type { LDClientBase } from "launchdarkly-js-sdk-common";

let ldClient: LDClientBase | undefined;

/**
 * Fetches the only instance of the LaunchDarkly client.
 */
export function getLdClient(): LDClientBase | null {
  if (ldClient) return ldClient;
  return null;
}

/**
 * Sets the only instance of the LaunchDarkly client. Be sure to call this at
 * least once before calling `get`.
 */
export function setLdClient(client: LDClientBase) {
  ldClient = client;
}
